import { useMockAuth } from './useMockAuth';
import { useRealAuth } from './useRealAuth';
export type { AuthAccount } from './useMockAuth';

export const IS_MOCK = import.meta.env.VITE_AUTH_MODE === 'mock';

export const useAuth = IS_MOCK ? useMockAuth : useRealAuth;
